import React from "react";

import { GuidedCallActionIcons } from "./GuidedCallActionIcons";
import { GuidedCallProgress } from "./GuidedCallProgress";

export function GuidedVideoSection(props) {
  const { currentStep, showLauncher, workflow } = props;

  if (!workflow) return null;

  return (
    <ul className="tw:mx-auto tw:hidden tw:lg:flex">
      <GuidedCallProgress currentStep={currentStep} workflow={workflow} />
      <GuidedCallActionIcons showLauncher={showLauncher} {...props} />
    </ul>
  );
}
